/** The accepted application snapshot takes priority over a later default-policy change. */
export function resolveTrialDays(...values) {
  for (const value of values) {
    if (typeof value !== 'number' && typeof value !== 'string') continue;
    const days = Number(value);
    if (Number.isInteger(days) && days >= 7 && days <= 90) return days;
  }
  return 7;
}
